import { render } from "./AutoAdjustSize.vue?vue&type=template&id=2fce267e"
import script from "./AutoAdjustSize.vue?vue&type=script&lang=js"
export * from "./AutoAdjustSize.vue?vue&type=script&lang=js"

import "./AutoAdjustSize.vue?vue&type=style&index=0&id=2fce267e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__